import googlelogo from "../assets/Config/Google_Drive_Logo.png";
import onelogo from "../assets/Config/oneDrive.png";
import notionlogo from "../assets/Config/notion.png";
export const CONFIG_IMG = {
  "One drive": onelogo,
  "Google drive": googlelogo,
  Notion: notionlogo,
  Notionpage: notionlogo,
};
